'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Small;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _AbstractTextElement = require('./AbstractTextElement');

var _AbstractTextElement2 = _interopRequireDefault(_AbstractTextElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Small(_ref) {
  var className = _ref.className,
      rest = _objectWithoutProperties(_ref, ['className']);

  var classes = (0, _classNames2.default)('private-microcopy', className);
  return _react2.default.createElement(_AbstractTextElement2.default, _extends({}, rest, { className: classes }));
}

Small.propTypes = _extends({}, _AbstractTextElement2.default.propTypes);

Small.defaultProps = _extends({}, _AbstractTextElement2.default.defaultProps, {
  tagName: 'small'
});

Small.displayName = 'Small';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/elements/Small.js
// module id = 27
// module chunks = 3 4 5